import React from 'react';
import { Form, Label, Popup, Icon } from 'semantic-ui-react';
import Cleave from 'cleave.js/react';
import PropTypes from 'prop-types';

import Required from '../Required';
import ErrorMessage from '../ErrorMessage';

const CurrencyLabel = () => (
  <Label
    basic
    style={{
      position: 'absolute',
      margin: 0,
      left: 1,
      borderTop: 0,
      borderBottom: 0,
      borderLeft: 0,
      marginTop: 1,
      height: 36,
      paddingTop: 12,
      width: 38,
      textAlign: 'center',
    }}
  >
    €
  </Label>
);

function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export default class Currency extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cleave: {},
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const { name } = this.props;
    const { values } = nextProps;
    if (this.props.values[name] !== values[name]) {
      this.state.cleave.setRawValue(values[name]);
    }
  };

  onValueInit = (cleave) => {
    this.setState({ cleave });
    const { values, name } = this.props;
    cleave.setRawValue(values[name]);
  };

  onCleaveBlur = (e) => {
    const { setFieldValue, name, blurCallback, onBlur } = this.props;
    setFieldValue(name, e.target.rawValue);

    if (blurCallback && typeof blurCallback === 'function') {
      blurCallback(e);
    }
    if (onBlur && isFunction(onBlur)) {
      onBlur(e.target.rawValue);
    }
  };

  cleave = null;

  render() {
    const { touched, errors, type, name, label, disabled, required, style, placeholder, noEuro } = this.props;

    return (
      <Form.Field error={Boolean(touched[name] && errors[name])} style={style} className="relative">
        <label htmlFor={name}>
          {label}
          <Required required={required} />
          {!!this.props.tooltip && (
            <Popup
              className="fieldTooltip"
              style={{ backgroundColor: '#333d68' }}
              inverted
              trigger={<Icon size="small" circular name="question" />}
            >
              {this.props.tooltip}
            </Popup>
          )}
        </label>
        <Cleave
          type={type}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          onInit={this.onValueInit}
          options={{
            numeral: true,
            numeralDecimalMark: ',',
            delimiter: '.',
            prefix: noEuro ? '' : '€         ',
            rawValueTrimPrefix: true,
          }}
          onBlur={this.onCleaveBlur}
        />
        {!noEuro && <CurrencyLabel />}
        {touched[name] && errors[name] && <ErrorMessage>{errors[name]}</ErrorMessage>}
      </Form.Field>
    );
  }
}

Currency.propTypes = {
  touched: PropTypes.object,
  errors: PropTypes.object,
  type: PropTypes.string,
  values: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  noEuro: PropTypes.bool,
  tooltip: PropTypes.string,
  onBlur: PropTypes.func,
  setFieldValue: PropTypes.func,
  blurCallback: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Forms/UI/Input/currency.js